<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <!-- <PlayerList/> -->
  <div>
     <router-view></router-view>
     <Footer></Footer>
  </div>
</template>

<script>
import Footer from "./components/footer";
export default {
  name: "App",
  components: {
    Footer
    // HelloWorld、
    //PlayerList
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
a,a:hover,a:active{
  text-decoration: none;
}
a:active{
color:#373D41;
}
a{color:#373D41;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
